import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/workforce')({ component: WorkforceLayout });

/** Nessun chrome di rotta: la pagina (DesktopHR su /workforce) ha già header + tab MaeDesign.
 *  Le sotto-rotte restano raggiungibili via URL, senza doppia barra di tab. */
function WorkforceLayout() {
  return <Outlet />;
}
